export default {
  total: "Gesamt",
  add_products: "+ Artikel hinzufügen",
  order_ahead: 'Nur Vorbestellungen',

  error_messages: {
    outside_delivery_times: "Außerhalb der Lieferzeiten",
  },
};
